var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Modal, Button } from '@appspotr/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
// import * as introActions from '@project/store/introductionModal/actions';
import { ModalLink, PInfoModal, HInfoModal, UInfoModal, LInfoModal, ModalFooter, ModalHeader, ImageWrapper, LinkInfoModal, ModalHeaderText, ModalLeftContent, ModalMainContent, ModalHeaderImage, ModalRightContent, } from './styles';
import { getWelcomeModalData } from '@project/store/introductionModal/selectors';
import { useLocation } from 'react-router-dom';
import { filteredPath } from './helpers';
var WelcomeModal = function () {
    var _a;
    var _b = useState(false), introModalShow = _b[0], setIntroModalShow = _b[1];
    var _c = useState(''), pathForStorage = _c[0], setPathForStorage = _c[1];
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var modal = useSelector(getWelcomeModalData).welcomeModalData;
    if ((modal === null || modal === void 0 ? void 0 : modal.type) == 'welcome' && pathForStorage !== '') {
        var welcomeStorePath = pathForStorage.split('/').join('_');
        var checkPath = localStorage.getItem("introModal_".concat(welcomeStorePath))
            ? localStorage.getItem("introModal_".concat(welcomeStorePath))
            : null;
        if (!checkPath) {
            localStorage.setItem("introModal_".concat(welcomeStorePath), 'true');
            setIntroModalShow(!introModalShow);
        }
    }
    useEffect(function () {
        var introPath = __spreadArray([], pathname === null || pathname === void 0 ? void 0 : pathname.split('/'), true);
        var path = filteredPath(introPath);
        setPathForStorage(path);
        // dispatch(introActions.introductionWelcomeModalData(path) as any);
    }, [dispatch, introModalShow, pathname]);
    var renderFooter = function () { return (_jsxs(ModalFooter, { children: [_jsx(ModalLink, __assign({ href: modal === null || modal === void 0 ? void 0 : modal.readMore, target: "_blank" }, { children: _jsx(Button, __assign({ type: "outline", style: { marginRight: 10 } }, { children: "Learn More" })) })), _jsx(Button, __assign({ type: "primary", onClick: function () { return setIntroModalShow(!introModalShow); } }, { children: "Continue" }))] })); };
    var renderHeader = function () { return (_jsxs(ModalHeader, { children: [_jsx(ModalHeaderImage, { src: modal === null || modal === void 0 ? void 0 : modal.icon, alt: " ", onError: function (e) {
                    e.target.style = 'display: none';
                } }), _jsx(ModalHeaderText, { children: modal === null || modal === void 0 ? void 0 : modal.mainTitle })] })); };
    return (_jsx("div", { children: _jsxs(Modal, __assign({ size: "md", contentStyle: { height: 'auto' }, header: renderHeader(), closeModal: function () { return setIntroModalShow(!introModalShow); }, isOpen: introModalShow, footer: renderFooter() }, { children: [_jsx(ImageWrapper, { src: modal === null || modal === void 0 ? void 0 : modal.image, alt: " ", onError: function (e) {
                        e.target.style = 'display: none';
                    } }), _jsxs(ModalMainContent, { children: [_jsxs(ModalLeftContent, { children: [_jsx(HInfoModal, { children: modal === null || modal === void 0 ? void 0 : modal.leftTitle }), _jsx(PInfoModal, { children: modal === null || modal === void 0 ? void 0 : modal.leftContent })] }), _jsxs(ModalRightContent, { children: [_jsx(HInfoModal, { children: modal === null || modal === void 0 ? void 0 : modal.rightTitle }), _jsx(UInfoModal, { children: (_a = modal === null || modal === void 0 ? void 0 : modal.rightContent) === null || _a === void 0 ? void 0 : _a.map(function (item, index) { return (_jsx(LInfoModal, { children: _jsx(LinkInfoModal, __assign({ href: item === null || item === void 0 ? void 0 : item.link, target: "_blank" }, { children: item === null || item === void 0 ? void 0 : item.label })) }, index)); }) })] })] })] })) }));
};
export default WelcomeModal;
